export default __webpack_public_path__ + "static/solutions-6-b066d80c71639c4f1fba55628beb81ea.webp";